import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { ApiError } from '../api.ts';
import { en } from './en.ts';
import { srLatn } from './sr-Latn.ts';

export const supportedLocales = ['sr-Latn', 'en'] as const;
export type SupportedLocale = (typeof supportedLocales)[number];
const storageKey = 'sprintdeck.locale';

function initialLocale(): SupportedLocale {
  const stored = localStorage.getItem(storageKey);
  if (stored === 'en' || stored === 'sr-Latn') return stored;
  return navigator.language.toLowerCase().startsWith('en') ? 'en' : 'sr-Latn';
}

void i18next.use(initReactI18next).init({
  resources: { 'sr-Latn': { translation: srLatn }, en: { translation: en } },
  lng: initialLocale(),
  fallbackLng: 'sr-Latn',
  interpolation: { escapeValue: false },
  returnNull: false,
});

document.documentElement.lang = i18next.language;

export function setLocale(locale: SupportedLocale) {
  localStorage.setItem(storageKey, locale);
  document.documentElement.lang = locale;
  return i18next.changeLanguage(locale);
}

export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    const key = `errors.${error.code}`;
    if (i18next.exists(key)) return i18next.t(key);
  }
  return i18next.t('errors.generic');
}

export { i18next };
